export class PreRegisteredStudentAutocompleteSearchDTO {
    constructor(
        public statuses: string[],
        public text?: string,
        public schoolId?: string
    ) {
        this.statuses = statuses ? statuses : [];
        this.text = text ? text : '';
        this.schoolId = schoolId ? schoolId : null;
    }
}
